import React from 'react';
import { Form } from 'react-bootstrap';

export const InputCustom = ({ field, error, ...props }) => {
  return (
    <Form.Group className={props.className}>
      {props.label ? <Form.Label>{props.label}</Form.Label> : null}
      <div className="position-relative">
        <Form.Control
          className={props.icon ? 'input-text-icon' : 'input-text'}
          type={props.type}
          placeholder={props.placeholder}
          {...field}
          {...props}
        />
        {props.icon && props.icon}
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </div>
    </Form.Group>
  );
};

export const SelectInputCustom = (props) => {
  // Generar un ID único basado en el label o un valor aleatorio
  const selectId = props.label ? `select_${props.label.replace(/\s+/g, '_').toLowerCase()}` : `select_${Math.random().toString(36).substring(2, 11)}`;
  
  return (
    <Form.Group controlId={selectId} className="mt-0 w-100">
      {props.label && <Form.Label className={`${props?.className} text-light`}>{props.label}</Form.Label>}
      <Form.Select
        placeholder={props.placeholder}
        onChange={(e) => props.onCheckedItem(e.target.value)}
        value={props.value}
        defaultValue={props.value}
        className={`input-control ${props.selectClassName}`}
      >
        {props.placeholder && <option value="">{props.placeholder}</option>}
        {props.choices?.map((choice, i) => (
          <option value={choice.id} key={choice.id}>
            {choice.value}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};
